var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 77,
    viewBox: "0 0 95 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H91C93.2091 0 95 1.79086 95 4V73C95 75.2091 93.2091 77 91 77H4C1.79086 77 0 75.2091 0 73V4Z",
    fill: "#020C41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4974 59.3333C51.3651 59.3333 55.0745 57.7969 57.8094 55.062C60.5443 52.3271 62.0807 48.6177 62.0807 44.75C62.0807 40.5833 59.9974 36.625 55.8307 33.2917C51.6641 29.9583 48.5391 24.9583 47.4974 19.75C46.4557 24.9583 43.3307 29.9583 39.1641 33.2917C34.9974 36.625 32.9141 40.5833 32.9141 44.75C32.9141 48.6177 34.4505 52.3271 37.1854 55.062C39.9203 57.7969 43.6297 59.3333 47.4974 59.3333Z",
    stroke: "white",
    strokeWidth: 3.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcon);
export default __webpack_public_path__ + "static/media/drop-icon.2af3bd935cbd06e387a3e7e2e8477632.svg";
export { ForwardRef as ReactComponent };